import React from 'react';

// eslint-disable-next-line react/prop-types
const Cta = ({ appLink }) => (
  <div>
    <div className="u-mt-8 u-mb-6">
      <a
        className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block"
        href={appLink}
        target="_blank"
      >
        Pay now your
      </a>
      <span className="u-text-large u-fw-bold">
        &nbsp;appointment<br />using our free app.
      </span>
    </div>
    <div className="u-flex">
      <a className="c-store-button u-mr-4" href={appLink} target="_blank">
        <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png" alt="" />
      </a>
      <a className="c-store-button" href={appLink} target="_blank">
        <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png" alt="" />
      </a>
    </div>
  </div>
);

export default Cta;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerUnpaidAppointment/components/Cta.jsx